/**
 * Conteúdo da seção Orçamento, copiado literalmente de `legacy/static-site`.
 *
 * Diferente das outras, aqui não há foto nem número de demonstração — só as
 * opções do formulário e o texto ao lado. O que precisa de conferência é o
 * WhatsApp de destino, que está em `content/contato.ts`.
 */

export const AMBIENTES_DO_FORMULARIO = [
  'Cozinha',
  'Dormitório',
  'Closet',
  'Sala / Home',
  'Home office',
  'Banheiro',
  'Área gourmet',
  'Comercial',
] as const;

export const PRAZOS = [
  'Assim que possível',
  'Em 1 a 3 meses',
  'Em 3 a 6 meses',
  'Ainda estou pesquisando',
] as const;

export const VANTAGENS = [
  'Visita de medição sem taxa',
  'Projeto 3D só depois do seu aceite',
  'Parcelamento em até 12x',
] as const;

export const PASSOS = [
  { numero: '01', rotulo: 'Ambiente', legenda: 'O que você quer planejar?' },
  { numero: '02', rotulo: 'Medidas', legenda: 'Uma noção de tamanho e prazo' },
  { numero: '03', rotulo: 'Contato', legenda: 'Como falamos com você' },
] as const;
